__webpack_require__.p = "/energy/paper/Circular_economy_microalgae/";